import { memo } from 'react'
import { MRT_ColumnDef } from 'mantine-react-table'
import { formatDateTimeMinus, size } from 'src/variable/constant'
import NotificationPageList from 'src/containers/Notification'
import CustomTooltip from 'src/components/CustomComponents/CustomTooltip'
import { frequency } from 'src/variable/notificationData'
import dayjs from 'dayjs'
import classes from './NotificationPage.module.scss'

function NotificationPage() {
	const columns: MRT_ColumnDef[] = [
		{
			accessorKey: 'no',
			header: 'No',
			size: size.zero,
		},
		{
			accessorKey: 'message_title',
			header: 'Title',
			size: size.zero,
			maxSize: size.text,
			Cell: ({ cell }) => {
				return (
					<CustomTooltip label={cell.getValue<string>()} maxWidth={size.text}>
						<div className={classes.titleCell}>
							<span className={classes.titleText}>
								{cell.getValue<string>()}
							</span>
						</div>
					</CustomTooltip>
				)
			},
		},
		{
			accessorKey: 'message_content',
			header: 'Content',
			size: size.zero,
			maxSize: size.text,
			Cell: ({ cell }) => {
				return (
					<CustomTooltip
						label={cell.getValue<string>()}
						maxWidth={size.mediumS}
					>
						<div className={classes.contentCell}>
							{cell.getValue<string>()}
						</div>
					</CustomTooltip>
				)
			},
		},
		{
			accessorKey: 'frequency',
			header: 'Frequency',
			size: size.zero,
			maxSize: size.text,
			Cell: ({ cell }) => (
				<span className={classes.frequencyBadge}>
					{frequency[cell.getValue<string>()] || 'One time'}
				</span>
			),
		},
		{
			accessorKey: 'sending_unix_timestamp',
			header: 'Sending time',
			size: size.zero,
			maxSize: size.text,
			Cell: ({ cell }) => (
				<div className={classes.dateCell}>
					<span className={classes.dateValue}>
						{dayjs(Number(cell.getValue<string>())).format(formatDateTimeMinus)}
					</span>
				</div>
			),
		},
		{
			accessorKey: 'ending_unix_timestamp',
			header: 'Ending time',
			size: size.zero,
			maxSize: size.text,
			Cell: ({ cell }) => {
				const value = cell.getValue<string | null>()
				return (
					<div className={classes.dateCell}>
						{value ? (
							<span className={classes.dateValue}>
								{dayjs(Number(value)).format(formatDateTimeMinus)}
							</span>
						) : (
							<span className={classes.muted}>No ending time</span>
						)}
					</div>
				)
			},
		},
		{
			accessorKey: 'created_at',
			header: 'Created at',
			size: size.zero,
			maxSize: size.text,
		},
	]
	const fields = [
		{
			value: 'message_title',
			label: 'Title',
		},
		{
			value: 'message_content',
			label: 'Content',
		},
	]
	return <NotificationPageList columns={columns} fields={fields} />
}

export default memo(NotificationPage)
